module.exports = __webpack_public_path__ + "static/img/icon-home_on.715129a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/show/footer/icon-home_on.png
// module id = nDJU
// module chunks = 156